import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container process-demand-letter-container mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "upload-form-container mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_4 = {
  class: "w-100 mb-3",
  open: ""
}
const _hoisted_5 = { class: "ps-2 mt-3" }
const _hoisted_6 = {
  key: 1,
  class: "w-100"
}
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = {
  key: 2,
  class: "processing-status-container d-flex align-items-center flex-md-column"
}
const _hoisted_9 = { class: "spinner-container" }
const _hoisted_10 = { class: "fw-bold fs-5 mb-3" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "fw-bold fs-5"
}
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "fw-bold fs-5" }
const _hoisted_17 = {
  key: 4,
  class: "fw-bold fs-5 mb-3"
}
const _hoisted_18 = {
  key: 5,
  class: "text-start fw-bold mb-4 mt-2 text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_start_processing = _resolveComponent("start-processing")!
  const _component_editor_section = _resolveComponent("editor-section")!
  const _component_progress_bar = _resolveComponent("progress-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status === _ctx.GENERAL_INFO_STATUS())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_start_processing, {
            "session-id": _ctx.sessionId,
            "handle-fetch-session-info": _ctx.handleFetchSessionInfo
          }, null, 8, ["session-id", "handle-fetch-session-info"])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.status === _ctx.COMPLETED_STATUS() || _ctx.status === _ctx.RETRIEVAL_PROCESSED_STATUS()
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.status === _ctx.COMPLETED_STATUS())
            ? (_openBlock(), _createBlock(_component_editor_section, {
                key: 0,
                modelValue: _ctx.demandLetter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.demandLetter) = $event)),
                title: "Demand Letter",
                editor: _ctx.editor,
                "editor-config": _ctx.editorConfig
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "btn btn-primary fw-bold align-self-center mt-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSaveDemandLetter && _ctx.handleSaveDemandLetter(...args)))
                  }, " Save ")
                ]),
                _: 1
              }, 8, ["modelValue", "editor", "editor-config"]))
            : _createCommentVNode("", true),
          _createElementVNode("details", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("summary", { class: "text-start" }, [
              _createElementVNode("h2", { class: "d-inline fs-4" }, "Retrieved Data")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_editor_section, {
                modelValue: _ctx.facts,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.facts) = $event)),
                title: "Facts",
                editor: _ctx.editor,
                "editor-config": _ctx.editorConfig
              }, null, 8, ["modelValue", "editor", "editor-config"]),
              _createVNode(_component_editor_section, {
                modelValue: _ctx.liability,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.liability) = $event)),
                title: "Liability",
                editor: _ctx.editor,
                "editor-config": _ctx.editorConfig
              }, null, 8, ["modelValue", "editor", "editor-config"]),
              _createVNode(_component_editor_section, {
                modelValue: _ctx.injuriesMedicals,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.injuriesMedicals) = $event)),
                title: "Injuries/Medicals",
                editor: _ctx.editor,
                "editor-config": _ctx.editorConfig
              }, null, 8, ["modelValue", "editor", "editor-config"]),
              _createVNode(_component_editor_section, {
                modelValue: _ctx.pipBills,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pipBills) = $event)),
                title: "PIP/Bills",
                editor: _ctx.editor,
                "editor-config": _ctx.editorConfig
              }, null, 8, ["modelValue", "editor", "editor-config"])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary fw-bold align-self-center",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateRetrieval && _ctx.handleUpdateRetrieval(...args)))
            }, " Save & Generate ")
          ]),
          (_ctx.files)
            ? (_openBlock(), _createElementBlock("details", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("summary", { class: "text-start" }, [
                  _createElementVNode("h3", { class: "d-inline fs-4" }, "Raw PDF Data")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.id
                  }, [
                    _createElementVNode("h4", null, _toDisplayString(file.name), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((file.ocr) = $event),
                      class: "textarea w-100 my-3"
                    }, null, 8, _hoisted_7), [
                      [_vModelText, file.ocr]
                    ])
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  class: "btn btn-primary fw-bold align-self-center",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateOcr && _ctx.handleUpdateOcr(...args)))
                }, " Save & Retrieve ")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.status === _ctx.OCR_PROCESSING_STATUS() ||
        _ctx.status === _ctx.RETRIEVAL_PROCESSING_STATUS() ||
        _ctx.status === _ctx.GENERATOR_PROCESSING_STATUS()
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "spinner-border",
              style: {"width":"3rem","height":"3rem"},
              role: "status"
            }, null, -1)),
            _createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mb-3" }, " We are processing your documents. Please wait... ", -1)),
              _createElementVNode("div", _hoisted_11, "Stage: " + _toDisplayString(_ctx.formatStatus(_ctx.status)), 1),
              _createElementVNode("div", null, [
                (_ctx.status === _ctx.RETRIEVAL_PROCESSING_STATUS())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, " ETA: 5 minutes "))
                  : (_ctx.status === _ctx.GENERATOR_PROCESSING_STATUS())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ETA: 2 minutes "))
                    : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.status === _ctx.OCR_PROCESSING_STATUS())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.sessionProgress > 0)
                  ? (_openBlock(), _createBlock(_component_progress_bar, {
                      key: 0,
                      class: "w-100",
                      progress: _ctx.sessionProgress * 100,
                      "progress-text": _ctx.progressMessage
                    }, null, 8, ["progress", "progress-text"]))
                  : _createCommentVNode("", true),
                (_ctx.remainingTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "ETA: " + _toDisplayString(_ctx.formatTime(_ctx.remainingTime)), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.status === _ctx.OCR_PROCESSING_FAILED_STATUS() ||
        _ctx.status === _ctx.RETRIEVAL_PROCESSING_FAILED_STATUS() ||
        _ctx.status === _ctx.GENERATOR_PROCESSING_FAILED_STATUS()
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, "Error: " + _toDisplayString(_ctx.formatStatus(_ctx.status)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.formatStatus(_ctx.status) === _ctx.UNKNOWN_STATUS())
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Unknown Status: " + _toDisplayString(_ctx.status), 1))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}